export default {
  wrapper: {
    variants: {
      information: {
        bg: 'info_bg',
        borderColor: 'info_border'
      },
      error: {
        bg: 'error_bg',
        borderColor: 'error_border'
      },
      warning: {
        bg: 'warning_bg',
        borderColor: 'warning_border'
      },
      success: {
        bg: 'success_bg',
        borderColor: 'success_border'
      },
      default: {
        backgroundColor: 'grey-0',
        borderColor: 'grey-20'
      }
    }
  }
};